import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';
import { ToastService } from 'src/app/toast/toast.service';

@Component({
  selector: 'app-feed-back',
  templateUrl: './feed-back.component.html',
  styleUrls: ['./feed-back.component.scss']
})
export class FeedBackComponent implements OnInit {
  feedbackForm!:FormGroup
  constructor(private toastService: ToastService,private form: FormBuilder,private commonService:CommonService) {
 
  }
  ngOnInit():void{
   this.feedbackForm=this.form.group({
      name:['',Validators.required],
      email:['',[Validators.required, Validators.email]],
      mobileNo:['',Validators.required],
      content:['',Validators.required],
      easeOfNavigation:['',Validators.required],
      informationProcess:['',Validators.required],
      accessibility:['',Validators.required],
      message:['',Validators.required]
    })
  }

  
  addFeedback(){
    // this.feedbackForm.markAllAsTouched()
      const feedbackData = {
      UserName: this.feedbackForm.value.name?this.feedbackForm.value.name?.trim():null,
      Email: this.feedbackForm.value.email?this.feedbackForm.value.email?.trim():null,
      MobileNumber: this.feedbackForm.value.mobileNo?this.feedbackForm.value.mobileNo?.trim():null,
      ContentAndInformation: this.feedbackForm.value.content?this.feedbackForm.value.content?.trim():null,
      EaseOfNavigation:this.feedbackForm.value.easeOfNavigation?this.feedbackForm.value.easeOfNavigation?.trim():null,
      InformationProcess:this.feedbackForm.value.informationProcess?this.feedbackForm.value.informationProcess?.trim():null,
      Accessibility:this.feedbackForm.value.accessibility?this.feedbackForm.value.accessibility?.trim():null,
      Message: this.feedbackForm.value.message?this.feedbackForm.value.message?.trim():null
    };
    if (this.feedbackForm.valid) {
      this.commonService.addFeedback(feedbackData).subscribe(
        (response) => {
          if(response.status===200){
            this.toastService.showSuccess(response.message);
            this.feedbackForm.reset();
          }else{
            this.toastService.showError(response.message);
          }
        },
        (error) => {
 
        }
      );
    } else {
      this.toastService.showError('Please fill out the form correctly.');
    }
  }

  allowOnlyNumbers(event: KeyboardEvent) {
  const charCode = event.key.charCodeAt(0);
  if (charCode < 48 || charCode > 57) {
    event.preventDefault(); // Block non-numeric input
  }
}

}
